import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Code } from 'src/app/models/common';
import { User, UserChannel, UserPaymentInfo } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CodeService } from 'src/app/services/code.service';
import { CommonService } from 'src/app/services/common.service';
import { OtpService } from 'src/app/services/otp.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-mypage-common-dialog',
  templateUrl: './mypage-common-dialog.component.html',
  styleUrls: ['./mypage-common-dialog.component.css']
})
export class MypageCommonDialogComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private userService: UserService,
    private authService: AuthService,
    private otpService: OtpService,
    private codeService: CodeService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<MypageCommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.isAdmin = this.commonService.getUserInfo().isAdmin
    this.userNo = data.userNo
    this.user = data.user
    this.userPaymentInfo = data.userPaymentInfo
    this.type = data.type
    if(this.type == 'addChannel') {
      this.popupTitle = '활동정보 추가하기'
    } else if(this.type == 'updateCorpCode') {
      this.cashbillYn = this.user.cashbillYn
      this.popupTitle = '사업자정보 수정'
      this.buttonTitle = '수정하기'
    } else if(this.type == 'regidentNumber') {
      //this.cashbillYn = this.user.cashbillYn
      this.popupTitle = '주민등록번호 수정'
      this.buttonTitle = '수정하기'
    } else if(this.type == 'updateAccount') {
      this.popupTitle = '계좌정보 수정'
      if(this.userPaymentInfo) {
        this.buttonTitle = '수정하기'
      }
      this.getBankCodeList()
    } else if(this.type == 'updateTel') {
      this.popupTitle = '핸드폰번호 수정'
      this.buttonTitle = '수정하기'
    } else if(this.type == 'updatePassword') {
      this.popupTitle = '비밀번호 변경'
      this.buttonTitle = '변경하기'
    } else if(this.type == 'addScreenshot') {
      this.userChannel = data.userChannel
      this.popupTitle = '스크린샷 등록하기'
    } else if(this.type == 'gradeInfo') {
      this.popupTitle = '오아시스버디 등급별 혜택 안내'
    }
  }

  isShowEventBanner: boolean = moment().isBefore(moment('2025-05-31 00:00:00'))
  isAdmin: boolean = false
  popupTitle: string
  buttonTitle: string = '등록하기'
  userNo: number
  type: string
  user: User
  userPaymentInfo: UserPaymentInfo
  isAgree: boolean = false
  ngOnInit(): void {
  }
  bankCodeList: Code[]
  getBankCodeList() {
    this.codeService.getBankCodeList().subscribe(res => {
      this.bankCodeList = res.data
    })
  }
  proc() {
    if(this.type == 'addChannel') {
      this.addChannel()
    } else if(this.type == 'addScreenshot'){
      this.addScreenshot()
    } else if(this.type == 'updateTel'){
      this.updateTel()
    } else if(this.type == 'updateAccount'){
      if(!this.isAgree) {
        return alert("개인정보 수집 및 이용에 동의해 주세요")
      }
      this.updateAccount()
    } else if(this.type == 'updateCorpCode'){
      this.updateCorpCode()
    } else if(this.type == 'regidentNumber'){
      if(!this.isAgree) {
        return alert("개인정보 수집 및 이용에 동의해 주세요")
      }
      this.updateRegidentNumber()
    } else if(this.type == 'updateCorpCode'){
      this.updateCorpCode()
    } else if(this.type == 'updatePassword'){
      this.updatePasswordPro()
    } else {
      alert("준비중입니다.")
    }
  }
  //활동채널
  userChannel: UserChannel = new UserChannel()
  screenshotFile: File    // 스크린샷
  screenshotFileName: string
  addChannel() {
    if(!this.userChannel.channelType || this.userChannel.channelType == '') {
      return alert('채널을 유형을 선택해 주세요')
    }
    if(!this.userChannel.channelUrl || !this.userChannel.channelUrl.startsWith('http')) {
      return alert('URL을 정확하게 입력해 주세요')
    }
    const formData = new FormData();
    formData.append('req', new Blob([JSON.stringify(this.userChannel)], { type: "application/json" }))
    if(this.screenshotFile) {
      formData.append("imageFile", this.screenshotFile)
    }
    this.spinner.show()
    this.userService.addChannel(formData).subscribe(res => {
      this.spinner.hide()
      alert("정상적으로 등록 되었습니다.")
      this.popupClose()
    })
  }
  addScreenshot() {
    const formData = new FormData();
    if(this.screenshotFile) {
      formData.append("imageFile", this.screenshotFile)
    }
    this.spinner.show()
    this.userService.addScreenshot(this.userChannel.userChannelNo, formData).subscribe(res => {
      this.spinner.hide()
      alert("정상적으로 등록 되었습니다.")
      this.popupClose()
    })
  }
  onScreenshotFileChange(files: FileList, event: any) {
    if (files && files.length > 0) {
      this.screenshotFile = files[0]
      this.screenshotFileName = this.screenshotFile.name
      //console.log(this.licenseFile.size)
    }
  }
  newTel: string
  otpCode: string
  isOtpSend: boolean = false
  updateTelOtpSend() {
    if(!this.newTel) {
      return alert("핸드폰 번호를 입력해 주세요")
    }
    if(this.newTel == this.user.tel) {
      return alert("등록된 핸드폰 번호와 동일합니다")
    }
    this.newTel = this.newTel.replace(/-/gi, "")
    if(!(this.newTel.startsWith('010') && this.newTel.length == 11)) {
      return alert("핸드폰 번호를 확인해 주세요")
    }
    this.otpService.updateTelOtpSend(this.newTel).subscribe(res => {
      this.isOtpSend = true
      this.otpCode = null
      this.timer()
    })
  }
  isOtpConfirmTry: boolean = false
  isOtpConfirm: boolean = false
  updateTelOtpCheck() {
    if(!this.otpCode) {
      return alert("인증번호를 입력해 주세요")
    }
    this.isOtpConfirmTry = true
    this.otpService.updateTelOtpCheck(this.newTel, this.user.userId, this.otpCode, this.intervalCheckTime).subscribe(res => {
      this.isOtpConfirm = res.data
      this.displayTime = ''
      clearInterval(this.timerInterval)
      if(this.isOtpConfirm) {
        this.toastr.success("인증이 완료되었습니다")
      } else {
        alert("인증번호가 일치하지 않습니다")
        this.isOtpConfirmTry = false
        this.isOtpSend = false
        this.otpCode = null
        this.newTel = null
      }
    })
  }
  intervalCheckTime: number = 5
  displayTime: string
  timerInterval: any
  timer() {
    let minute = this.intervalCheckTime
    let seconds: number = minute * 60
    let textSec: any = "0"
    let statSec: number = 60
    const prefix = minute < 10 ? "0" : "";
    this.timerInterval = setInterval(() => {
      seconds--
      if (statSec != 0) {
        statSec--
      } else {
        statSec = 59
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else {
        textSec = statSec;
      }
      this.displayTime =  prefix + (Math.floor(seconds / 60)) + ':' + textSec
      if (seconds == 0) {
        clearInterval(this.timerInterval)
        this.isOtpSend = false
      }
    }, 1000)
  }
  updateTel() {
    if(this.isAdmin) {
      this.spinner.show()
      this.userService.updateTelForAdmin(this.userNo, this.newTel).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 변경 되었습니다.")
        this.popupClose()
      })
    } else {
      if(!this.isOtpConfirm) {
        return alert('핸드폰 인증을 진행해 주세요')
      }
      this.spinner.show()
      this.userService.updateTel(this.newTel, this.otpCode).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 변경 되었습니다.")
        this.popupClose()
      })
    }
  }
  bankCode: string = ''
  accountNumber: string
  depositor: string
  popupClose() {
    this.dialogRef.close();
  }
  updateAccount() {
    if(this.bankCode == '') {
      return alert("은행을 선택해 주세요")
    }
    if(!this.depositor || this.depositor == '') {
      return alert("예금주명을 입력해 주세요")
    }
    if(!this.accountNumber || this.accountNumber == '') {
      return alert("계좌번호를 입력해 주세요")
    }
    if(!this.licenseFile) {
      return alert('통장사본을 첨부해 주세요')
    }
    /*
    this.spinner.show()
    this.userService.updateUserPaymentInfo(this.bankCode, this.accountNumber).subscribe(res => {
      this.spinner.hide()
      alert("정상적으로 처리 되었습니다.")
      this.popupClose()
    })
    */
    if(this.isAdmin) {
      let metaData: UserPaymentInfo = new UserPaymentInfo()
      metaData.bankCode = this.bankCode
      metaData.accountNumber = this.accountNumber
      metaData.depositor = this.depositor
      const formData = new FormData();
      formData.append('metaData', new Blob([JSON.stringify(metaData)], { type: "application/json" }))
      if(this.licenseFile) {
        formData.append("imageFile", this.licenseFile)
      }
      this.spinner.show()
      this.userService.updateUserPaymentInfoForAdmin(this.userNo, formData).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 처리 되었습니다.")
        this.popupClose()
      })
    } else {
      let metaData: UserPaymentInfo = new UserPaymentInfo()
      metaData.bankCode = this.bankCode
      metaData.accountNumber = this.accountNumber
      metaData.depositor = this.depositor
      const formData = new FormData();
      formData.append('metaData', new Blob([JSON.stringify(metaData)], { type: "application/json" }))
      if(this.licenseFile) {
        formData.append("imageFile", this.licenseFile)
      }
      this.spinner.show()
      this.userService.updateUserPaymentInfo(formData).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 처리 되었습니다.")
        this.popupClose()
      })
    }
  }
  corpCodePart1: string
  corpCodePart2: string
  corpCodePart3: string
  licenseFile: File    // 사업자등록증
  licenseFileName: string
  cashbillYn: string
  //thumbImgSrc = '';    // 프리뷰
  onFileChange(files: FileList, event: any) {
    if (files && files.length > 0) {
      this.licenseFile = files[0]
      this.licenseFileName = this.licenseFile.name
      //console.log(this.licenseFile.size)
    }
  }
  updateCorpCode() {
    let metaData: User = new User()
    metaData.userNo = this.userNo
    if(this.cashbillYn != this.user.cashbillYn) {
      metaData.cashbillYn = this.cashbillYn
    } 
    if(this.corpCodePart1 || this.corpCodePart2 || this.corpCodePart3) {
      let corpCode = this.corpCodePart1 + '-' + this.corpCodePart2 + '-' + this.corpCodePart3
      const regex: RegExp = /^([0-9]{3})-([0-9]{2})-([0-9]{5})$/
      let corpCodeCheck: boolean = regex.test(corpCode)
      if(!corpCodeCheck) {
        return alert("사업자 번호가 올바르지 않습니다.\nex>123-12-12345");
      }
      if(!this.licenseFile) {
        return alert('사업자 등록증을 첨부해 주세요')
      }
      metaData.corpCode = this.corpCodePart1 + '-' + this.corpCodePart2 + '-' + this.corpCodePart3
    }
    if(this.isAdmin) {
      const formData = new FormData();
      formData.append('metaData', new Blob([JSON.stringify(metaData)], { type: "application/json" }))
      if(this.licenseFile) {
        formData.append("corpImageFile", this.licenseFile)
      }
      this.spinner.show()
      this.userService.updateCorpCodeForAdmin(this.userNo, formData).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 처리 되었습니다.")
        this.popupClose()
      })
    } else {
      const formData = new FormData();
      formData.append('metaData', new Blob([JSON.stringify(metaData)], { type: "application/json" }))
      if(this.licenseFile) {
        formData.append("corpImageFile", this.licenseFile)
      }
      this.spinner.show()
      this.userService.updateCorpCode(formData).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 처리 되었습니다.")
        this.popupClose()
      })
    }
  }
  regidentNumberPart1: string
  regidentNumberPart2: string
  updateRegidentNumber() {
    let metaData: User = new User()
    metaData.userNo = this.userNo
    if(this.regidentNumberPart1 || this.regidentNumberPart2) {
      let regidentNumber = this.regidentNumberPart1 + '-' + this.regidentNumberPart2
      const regex: RegExp = /^([0-9]{6})-([0-9]{7})$/
      let regidentNumberCheck: boolean = regex.test(regidentNumber)
      if(!regidentNumberCheck) {
        return alert("주민등록번호가 올바르지 않습니다.");
      }
      if(!this.licenseFile) {
        return alert('신분증 사본을 첨부해 주세요')
      }
      metaData.regidentNumber = this.regidentNumberPart1 + '-' + this.regidentNumberPart2
    }
    
    if(this.isAdmin) {
      const formData = new FormData();
      formData.append('metaData', new Blob([JSON.stringify(metaData)], { type: "application/json" }))
      if(this.licenseFile) {
        formData.append("corpImageFile", this.licenseFile)
      }
      this.spinner.show()
      this.userService.updateRegidentNumberForAdmin(this.userNo, formData).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 처리 되었습니다.")
        this.popupClose()
      })
    } else {
      const formData = new FormData();
      formData.append('metaData', new Blob([JSON.stringify(metaData)], { type: "application/json" }))
      if(this.licenseFile) {
        formData.append("corpImageFile", this.licenseFile)
      }
      this.spinner.show()
      this.userService.updateRegidentNumber(formData).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 처리 되었습니다.")
        this.popupClose()
      })
    }
  }

  
  currentPassword: string
  updatePassword: string
  updatePasswordConfirm: string
  isPasswordCheck: boolean = false
  passwdCheckMsg: string
  checkPassword() {
    if(this.updatePassword) {
      let regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@\#$%<>^&*+-])[A-Za-z\d~!@\#$%<>^&*+-]{8,}$/
      if(!regex.test(this.updatePassword)) {
        this.passwdCheckMsg = "비밀번호는 영문,숫자,특수문자(~!@\#$%<>^&*+-)조합으로 8자이상만 가능합니다"
      } else {
        this.isPasswordCheck = true
        this.passwdCheckMsg = null
      }
    }
    this.checkConfirmPassword()
  }
  confirmPasswdCheckMsg: string
  isConfirmPasswordCheck: boolean = false
  checkConfirmPassword() {
    if(this.updatePassword != this.updatePasswordConfirm) {
      this.confirmPasswdCheckMsg = "비밀번호가 일치하지 않습니다"
      this.isConfirmPasswordCheck = false
    } else {
      this.confirmPasswdCheckMsg = null
      this.isConfirmPasswordCheck = true
    }
  }
  updatePasswordPro() {
    if(this.isAdmin) {
      if(!this.isPasswordCheck || !this.isConfirmPasswordCheck) {
        return alert('새 비밀번호를 확인해 주세요')
      }
      this.spinner.show()
      this.userService.updatePasswordForAdmin(this.userNo, this.updatePassword).subscribe(res => {
        this.spinner.hide()
        if(res.resultCode == '8888') {
          alert(res.message)
          this.popupClose()
        } else {
          alert("정상적으로 변경 되었습니다.")
          this.popupClose()
        }
      })
    } else {
      if(!this.currentPassword || this.currentPassword =='') {
        return alert('기존 비밀번호를 입력해 주세요')
      }
      if(!this.isPasswordCheck || !this.isConfirmPasswordCheck) {
        return alert('새 비밀번호를 확인해 주세요')
      }
      if(this.currentPassword == this.updatePassword) {
        return alert('기존 비밀번호와 새 비밀번호가 동일합니다.')
      } 
      
      this.spinner.show()
      this.userService.updatePasswordForBuddy(this.currentPassword, this.updatePassword).subscribe(res => {
        this.spinner.hide()
        if(res.resultCode == '8888') {
          alert(res.message)
          this.popupClose()
        } else {
          alert("정상적으로 변경 되었습니다.\n재 로그인 후 이용해 주세요")
          this.logout()
        }
      })
    }
  }

  logout(){
    this.authService.logout()
  }
}
